import HeaderNav from './HeaderNav';
import Section from './Section';
import Logo from './Logo';
import { useState } from 'react';

const Header = () => {

    const [openNav, setOpenNav] = useState(false);


    const handleMobileClick = () => {

       !openNav ? document.body.classList.add('lock') : document.body.classList.remove('lock');        
        setOpenNav(!openNav);
    }

    return (
        <header>
            <Section extraClasses='with-overflow'>
                <a href="#main" className="skip-nav">Skip Navigation</a><div className="logo">
                <a href="https://www.salubrishealth.com"><Logo /></a></div>
                <HeaderNav label="Main Navigation" openInMobile={openNav} />
                <a href="#" className={`mb ${openNav ? 'switch-to-open': ''}`} id="mobile-nav" onClick={handleMobileClick} aria-label="Click to view navigation"></a>
            </Section>
        </header> 
    );
}

export default Header;